"use client";

import { useSettingEnableProductQuickView } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingEnableProductQuickView";
import { Modal } from "@faire/web/slate/Modal";
import { Typography } from "@faire/web/slate/Typography";
import React, {
  createContext,
  PropsWithChildren,
  useState,
  useContext,
} from "react";

const ProductQuickViewContext = createContext<{
  setProductToken?: React.Dispatch<React.SetStateAction<string | undefined>>;
}>({ setProductToken: undefined });

export const ProductQuickViewContextProvider: React.FC<
  PropsWithChildren<{ surface: "search" | "category" }>
> = ({ children, surface }) => {
  const [productToken, setProductToken] = useState<string>();
  const { isEnabled } = useSettingEnableProductQuickView();

  return (
    <ProductQuickViewContext.Provider value={{ setProductToken }}>
      {children}
      {productToken && isEnabled ? (
        <Modal onClose={() => setProductToken(undefined)}>
          <Typography>{surface}</Typography>
          <Typography>{productToken}</Typography>
        </Modal>
      ) : null}
    </ProductQuickViewContext.Provider>
  );
};

export const useProductQuickView = () => {
  return useContext(ProductQuickViewContext);
};
